import { Globalize } from '@grapecity/wijmo';
import { ICellTemplateContext } from '@grapecity/wijmo.grid';
import { FlexGridCellTemplate, FlexGridColumn } from '@grapecity/wijmo.react.grid';
import clsx from 'clsx';
import _ from 'lodash';
import { Key } from 'react';

type CurrancyColumnTemplateProps = {
  symbol?: 'YEN' | 'USD' | 'NONE';
  binding: string;
  scale?: number;
};

type CurrancyColumnProps = {
  header: string;
  binding: string;

  key?: Key | null | undefined;
  [key: string]: any;
} & CurrancyColumnTemplateProps;

const getSymbol = (symbol: 'YEN' | 'USD' | 'NONE' | undefined) => {
  if (symbol === 'NONE') return '';
  if (symbol === 'USD') return '$';
  return '¥';
};

export const getCurrancyColumnTemplateFunction = (
  props: CurrancyColumnTemplateProps
): ((context: ICellTemplateContext) => JSX.Element) => {
  return (context: ICellTemplateContext) => {
    const value = _.get(context, `item.${props.binding}`);
    if (value === undefined || value === '' || value === null) return <></>;
    const cnvValue = Number(value);
    const symbol = getSymbol(props.symbol);
    const scale = props.scale ? props.scale : 4;
    if (!isNaN(cnvValue)) {
      const sign = cnvValue < 0 ? 'negative' : 'positive';
      return (
        <span className={clsx(sign)}>{`${symbol}${Globalize.formatNumber(
          cnvValue,
          `G${scale}`
        )}`}</span>
      );
    } else {
      return <></>;
    }
  };
};

export const CurrancyColumnTemplate = (props: CurrancyColumnTemplateProps) => {
  return (
    <FlexGridCellTemplate
      cellType="Cell"
      template={(context: ICellTemplateContext) => {
        const value = _.get(context, `item.${props.binding}`);
        if (value === undefined || value === '' || value === null) return <></>;
        const cnvValue = Number(value);
        const symbol = getSymbol(props.symbol);
        const scale = props.scale ? props.scale : 4;
        if (!isNaN(cnvValue)) {
          const sign = cnvValue < 0 ? 'negative' : 'positive';
          return (
            <span className={clsx(sign)}>{`${symbol}${Globalize.formatNumber(
              cnvValue,
              `G${scale}`
            )}`}</span>
          );
        } else {
          return <></>;
        }
      }}
    />
  );
};

export const CurrancyColumn = (props: CurrancyColumnProps) => {
  return (
    <FlexGridColumn {...props}>
      <FlexGridCellTemplate cellType="Cell" template={getCurrancyColumnTemplateFunction(props)} />
    </FlexGridColumn>
  );
};
